import React, { Component } from 'react';
import { COLOR } from '../../../const/color';
import { FaExternalLinkAlt } from 'react-icons/fa';
import SelectLocationModal from '../../../components/modals/SelectLocationModal';
import Button from '../../../components/buttons/Button';
import {
  AddressValidity,
  Address as OrderAddress,
} from '../../../types/orderTypes';
import { formatPhoneNumber } from '../../../utils/formatting';

interface Props {
  header: string;
  name: string;
  email: string;
  address: string;
  phone: string;
  longitude: number;
  latitude: number;
  validity: AddressValidity;
  onAddressLocationChange?: (longitude: number, latitude: number) => void;
  onAddressChange?: (newAddress: OrderAddress) => void;
}

interface State {
  showLocationModal: boolean;
}

export default class Address extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showLocationModal: false,
    };
  }

  render() {
    const {
      header,
      name,
      email,
      address,
      phone,
      longitude,
      latitude,
      validity,
    } = this.props;
    let addressColor: string;
    if (validity === AddressValidity.NEEDS_MANUAL_VALIDATION) {
      addressColor = COLOR.RED;
    } else if (validity === AddressValidity.CONFIRMED) {
      addressColor = COLOR.PRIMARY;
    }

    return (
      <div className="order__address">
        <h5>{header}</h5>
        <div className="address-line">
          <span>Name:</span>
          <span>{name}</span>
        </div>
        <div className="address-line">
          <span>Email:</span>
          <span>{email}</span>
        </div>
        <div className="address-line">
          <span>Address:</span>
          <span style={{ color: addressColor }}>{address}</span>
        </div>
        <div className="address-line">
          <span>Phone:</span>
          <span>{formatPhoneNumber(phone)}</span>
        </div>
        <div className="address-line__location">
          <a
            href={`https://maps.google.com/?q=${latitude},${longitude}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View location in Google Maps{' '}
            <span style={{ fontSize: 11 }}>
              <FaExternalLinkAlt />
            </span>
          </a>
          {validity === AddressValidity.NEEDS_MANUAL_VALIDATION && (
            <Button
              title="Confirm address location"
              type="danger"
              onClick={() =>
                this.setState({
                  showLocationModal: !this.state.showLocationModal,
                })
              }
            />
          )}
        </div>
        <div>
          {this.state.showLocationModal && (
            <SelectLocationModal
              longitude={longitude}
              latitude={latitude}
              targetAddress={address}
              onCloseModal={() => this.setState({ showLocationModal: false })}
              onLocationSelected={(longitude, latitude) => {
                this.setState({ showLocationModal: false });
                if (this.props.onAddressLocationChange) {
                  this.props.onAddressLocationChange(longitude, latitude);
                }
              }}
              onAddressSelected={newAddress => {
                this.setState({ showLocationModal: false });
                if (this.props.onAddressChange) {
                  this.props.onAddressChange(newAddress);
                }
              }}
            />
          )}
        </div>
      </div>
    );
  }
}
